/**
 * F5 zostawia użytkownika w tym samym miejscu (21.10): bieżąca strona i wybrany element żyją w adresie
 * (`?page=readiness&order=<id>`, `?page=clients&client=<id>`). Zmiany adresu przez `history.replaceState` —
 * bez wpisów w historii przeglądarki i bez przeładowania.
 */

/** Parametry, które należą do danej strony (przy zmianie strony pozostałe są usuwane). */
export const PAGE_PARAMS = { readiness: ['order'], clients: ['client'] };

export function getUrlParam(name) {
  try { return new URLSearchParams(window.location.search).get(name); } catch { return null; }
}

/** Scala `params` z bieżącym adresem (null / '' usuwa parametr). */
export function setUrlParams(params) {
  try {
    const q = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([k, v]) => { if (v == null || v === '') q.delete(k); else q.set(k, String(v)); });
    const s = q.toString();
    const next = `${window.location.pathname}${s ? `?${s}` : ''}${window.location.hash}`;
    if (next !== `${window.location.pathname}${window.location.search}${window.location.hash}`) window.history.replaceState(window.history.state, '', next);
  } catch { /* bez history */ }
}

/** Adres dla strony: `page` + tylko jej własne parametry (z bieżącego adresu). */
export function syncPageToUrl(page) {
  const own = PAGE_PARAMS[page] || [];
  const drop = Object.values(PAGE_PARAMS).flat().filter(k => !own.includes(k));
  setUrlParams({ page, ...Object.fromEntries(drop.map(k => [k, null])) });
}
